// auth-routing.module.ts
import { Injectable, NgModule, inject } from '@angular/core';
import {
  CanDeactivate,
  CanDeactivateFn,
  RouterModule,
  Routes,
} from '@angular/router';
import { AuthComponent } from './auth.component';
import { SecureGuard } from 'src/app/core/guards/secure.guard';
import { FeatureGuard } from 'src/app/core/guards/feature.guard';

const authChildRoutes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
    canActivate: [FeatureGuard],
    data: { featureFlag: 'login' },
  },
  {
    path: 'sign-up',
    loadComponent: () =>
      import('./sign-up/sign-up.component').then((m) => m.SignUpComponent),
    canActivate: [FeatureGuard],
    data: { featureFlag: 'signup' },
  },
  {
    path: 'recovery-account',
    loadChildren: () =>
      import('./recovery-account/recovery-account.module').then(
        (m) => m.RecoveryAccountModule,
      ),
    canActivate: [FeatureGuard],
    data: { featureFlag: 'recovery' },
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
    canActivate: [FeatureGuard],
    data: { featureFlag: 'recovery' },
  },
  {
    path: 'register-username',
    loadChildren: () =>
      import('./register-username/register-username.module').then(
        (m) => m.RegisterUsernameModule,
      ),
    canActivate: [FeatureGuard],
    data: { featureFlag: 'registerUserName' },
  },
];

@Injectable({
  providedIn: 'root',
})
export class ConfirmDeactivateGuard {
  canDeactivate(component: any): boolean | import('rxjs').Observable<boolean> {
    return false;
  }
}

// Step 3: Update the AuthRoutingModule
const routes: Routes = [
  {
    path: 'auth',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: AuthComponent,
    canActivate: [SecureGuard],
    children: [...authChildRoutes], // Spread the child routes here
    canDeactivate: [ConfirmDeactivateGuard], // Add the route guard - this fix a Loop
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule { }
